import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component - scrolls to top on route change
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let attempts = 0;
      let raf = 0;
      let timer = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          // re-adjust once layout/images settle
          timer = window.setTimeout(() => {
            const again = document.getElementById(id);
            if (again) again.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 500);
          return;
        }
        if (attempts++ < 60) raf = window.requestAnimationFrame(tryScroll);
      };
      raf = window.requestAnimationFrame(tryScroll);
      return () => {
        window.cancelAnimationFrame(raf);
        window.clearTimeout(timer);
      };
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const t = window.setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }), 60);
    return () => window.clearTimeout(t);
  }, [pathname, hash]);


  return null;
};

export default ScrollToTop;
